<template>
  <v-container fluid class="fill-height bg-grey-lighten-4">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="9" xl="7">
        <v-card elevation="8" class="mx-auto mb-4" style="border-top: 8px solid var(--color-orange-primary);">
          <v-card-text class="pa-8">
            <!-- Logo and Header -->
            <div class="text-center mb-8">
              <router-link to="/">
                <v-img 
                  src="https://ia-link.com/logogallopulo" 
                  alt="Logo Estudio Gallo Puló" 
                  max-height="60"
                  max-width="200"
                  class="mx-auto mb-4"
                />
              </router-link>
              <h2 class="text-h4 font-heading text-dark-charcoal mb-2">
                Contactanos
              </h2>
              <p class="text-body-2 text-grey-darken-1">
                Comentanos sobre tus necesidades y nosotros te brindaremos una solución integral y a medida para usted
              </p>
            </div>

            <v-row>
              <!-- Left Column: Contactos -->
              <v-col cols="12" md="6" class="border-e-md">
                <h3 class="text-h6 font-weight-bold text-center mb-4">
                  Encuentranos
                </h3>
                
                <!--Direccion-->
                <v-row>
                  <v-col cols="12">
                    <v-list density="compact">
                      <v-list-subheader class="text-subtitle-1 font-weight-bold text-brand-brown mb-2">
                        Dirección
                      </v-list-subheader>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-btn
                            variant="text"
                            color="orange"
                            href="https://maps.app.goo.gl/BgVKuLZgW8SWgKon7"
                            target="_blank"
                            class="pa-0 justify-start text-body-2 mb-2"
                            style="text-transform: none; height: auto; min-width: auto;"
                          >
                            <v-icon start size="40">mdi-map-marker</v-icon>
                          </v-btn>
                        </template>
                        <v-list-item-title class="text-body-2 text-wrap">
                          10 De Octubre 200 | Salta - Capital
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>

                <!--Contacto-->
                <v-row>
                  <v-col cols="12">
                    <v-list density="compact">
                      <v-list-subheader class="text-subtitle-1 font-weight-bold text-brand-brown mb-2">
                        Contacto
                      </v-list-subheader>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-btn
                            variant="text"
                            color="grey-lighten-1"
                            href="mailto:estudio@estudiogallopulo.com.ar"
                            class="pa-0 justify-start text-body-2 mb-2"
                            style="text-transform: none; height: auto; min-width: auto;"
                          >
                            <v-icon start size="40">mdi-email</v-icon>
                          </v-btn>
                        </template>
                        <v-list-item-title class="text-body-2 text-wrap">
                          estudio@estudiogallopulo.com.ar
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-btn
                            variant="text"
                            color="grey-lighten-1"
                            class="justify-start pa-0"
                            style="text-transform: none; height: auto; min-width: auto;"
                            :href="`tel:+5493876203088`"
                          >
                            <v-icon start size="40">mdi-phone</v-icon>
                          </v-btn>
                        </template>
                        <v-list-item-title class="text-body-2 text-wrap">
                          387 620-3088
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>

                <!--Redes Sociales-->
                <v-row>
                  <v-col cols="12">
                    <v-list density="compact">
                      <v-list-subheader class="text-subtitle-1 font-weight-bold text-brand-brown mb-2">
                        Nuestras Redes Sociales
                      </v-list-subheader>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-btn
                            variant="text"
                            color="#833AB4"
                            href="https://www.instagram.com/estudiogallopulo/"
                            target="_blank"
                            class="justify-start pa-0"
                            style="text-transform: none; height: auto; min-width: auto;"
                          >
                            <v-icon start size="40">mdi-instagram</v-icon>
                          </v-btn>
                        </template>
                        <v-list-item-title class="text-body-2 text-wrap">
                          Instagram
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-btn
                            variant="text"
                            color="blue"
                            href="https://www.facebook.com/estudiogallopulo"
                            target="_blank"
                            class="justify-start pa-0"
                            style="text-transform: none; height: auto; min-width: auto;"
                          >
                            <v-icon start size="40">mdi-facebook</v-icon>
                          </v-btn>
                        </template>
                        <v-list-item-title class="text-body-2 text-wrap">
                          Facebook
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-col>
              
              <!-- Right Column: Formulario -->
              <v-col cols="12" md="6">
                <h3 class="text-h6 font-weight-bold text-center mb-4">
                  Formulario
                </h3>

                <v-form @submit.prevent="handleContacto">
                  <v-text-field
                    v-model="contactoForm.nombre"
                    label="Nombre"
                    placeholder="Nombre"
                    variant="outlined"
                    class="mb-4"
                    color="orange"
                  />

                  <v-text-field
                    v-model="contactoForm.mail"
                    label="Correo Electronico"
                    placeholder="example@example.com"
                    variant="outlined"
                    class="mb-4"
                    color="orange"
                  />

                  <v-text-field
                    v-model="contactoForm.telefono"
                    label="Numero Contacto"
                    placeholder="387-0000-000"
                    type="tel"
                    variant="outlined"
                    class="mb-4"
                    color="orange"
                  />

                  <v-textarea
                    v-model="contactoForm.motivo"
                    label="Motivo"
                    placeholder="Escriba su Motivo de Contacto"
                    variant="outlined"
                    class="mb-4"
                    color="orange"
                    rows="4"
                  />

                  <v-btn
                    type="submit"
                    color="orange"
                    size="large"
                    block
                    class="mb-6"
                    elevation="2"
                    prepend-icon="mdi-send"
                  >
                    Enviar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>

            <!-- Back to Home -->
            <div class="text-center mt-6">
              <v-btn
                to="/"
                variant="text"
                color="grey-darken-1"
                prepend-icon="mdi-arrow-left"
              >
                Volver al inicio
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

// 1. Inicializar el store de Vuex
const store = useStore()

const loading = ref(false)
const error = ref(false)
const successMessage = ref(false)

const contactoForm = ref({
  nombre: '',
  mail: '',
  telefono: '',
  motivo: ''
})

// 4. Función que se ejecuta al hacer clic en "Enviar"
const handleContacto = async () => {
  loading.value = true

  const result = await store.dispatch("contact/submitContactForm", contactoForm.value)

  if (result.success) {
    successMessage.value = "Gracias por contactarte con nosotros. Te responderemos pronto."
    contactoForm.value = { nombre: '', mail: '', telefono: '', motivo: '' }
  } else {
    alert(result.message || "Error al guardar la noticia")
  }

  loading.value = false
}

// 5. Función para limpiar mensajes de error/éxito
const clearMessages = () => {
  store.dispatch('contact/clearMessages')
}
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
